<style lang="scss" scoped>
@import '@@/assets/css/global.scss';

.wo {
  position: relative;
  padding: 12px;
  color: white;
  border-radius: 4px;
  flex-shrink: 0;
  height: 100%;
  box-sizing: border-box;
  .infos {
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      .info {
        margin-bottom: 4px;
        font-size: 14px;
      }
    }

    .right {
      flex-shrink: 0;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
    }
  }

  .quan {
    position: absolute;
    bottom: 12px;
    right: 12px;
    font-size: 28px;
  }
}

.xinjian {
  background: $c-info;
}

.fafang {
  background: $c-warning;
}

.zanting {
  background: $c-error;
}

.shengchanzhong {
  background: $c-primary;
}

.guanbi {
  background: black;
}

.wangong {
  background: $c-success;
}
</style>
<template>
  <div
    v-if="wo"
    :style="{ 'min-height': minHeight + 'px' }"
    @click="chooseWo()"
    class="wo"
    :class="{
      xinjian: wo.woStat == 1,
      fafang: wo.woStat == 2,
      zanting: wo.woStat == 3,
      shengchanzhong: wo.woStat == 4,
      guanbi: wo.woStat == 5,
      wangong: wo.woStat == 6
    }"
  >
    <div class="infos">
      <div class="left">
        <!-- <div class="info">{{ $t('设备') }}:{{ wo.productionCellName }}</div> -->
        <div class="info" style="font-size: 22px;font-weight: bold;">{{ wo.no }}</div>

        <div class="info">{{ $t('chanpinmingcheng') }}:{{ wo.productionName }}</div>
        <div class="info">{{ $t('mujubianma') }}:{{ wo.modelNo }}</div>
        <div class="info">{{ $t('shiji/jihuachanliang') }}:{{ wo.actualQty + '/' + wo.planQty }}</div>
        <div class="info">{{ $t('liangpinlv') }}:{{ (wo.finishedQty / wo.productsQty) | number(1) }}</div>
        <div class="info">{{ $t('shengchanjindu') }}:{{ wo.progress | number(1) }}</div>
        <div class="info">{{ $t('chuangjianshijian') }}:{{ wo.gmtCreate | time('YYYY-MM-DD HH:mm:ss') }}</div>
        <div class="info" v-if="wo.finishedDate">{{ $t('yvjiwangong/shengyv(h)') }}:{{ wo.finishedDate | time('MM-DD HH:mm') }}/{{ wo.remainTime.toFixed(1) }}</div>
      </div>
      <div class="right">
        <div class="state">{{ wo.woStat | dict('PRODUCTION_WO_STATUS') }}</div>
      </div>
    </div>
    <i v-if="wo.isSelected == true" class="quan el-icon-success"></i>
  </div>
</template>

<script>
export default {
  name: 'gongdan_card',
  components: {},
  props: {
    wo: null,
    minHeight: 1000
  },

  data() {
    return {};
  },

  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},

  methods: {
    chooseWo() {
      this.$emit('chooseWo', this.utils.copy(this.wo));
    }
  }
};
</script>
